const PDF_MIME_TYPE = 'application/pdf';
const PASSWORD_EXCEPTION = 'PasswordException';

export const PASSWORD_PROTECTED_FILE_ERROR =
  'The file is password protected. Please upload a file without a password';

// pdf.js is lazy-loaded so it only lands in the bundle when a PDF is picked
const loadPdfjs = async () => {
  const [{ pdfjs }, { default: workerSrc }] = await Promise.all([
    import('react-pdf'),
    import('../../pdf-worker')
  ]);
  if (!pdfjs.GlobalWorkerOptions.workerSrc) {
    pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
  }
  return pdfjs;
};

// Resolves true only when the PDF needs a password to open. Owner-password
// (permission-restricted) PDFs still open, so they are treated as valid.
export const isPasswordProtectedPdf = async (file: File): Promise<boolean> => {
  if (file.type !== PDF_MIME_TYPE) return false;
  try {
    const pdfjs = await loadPdfjs();
    const data = new Uint8Array(await file.arrayBuffer());
    const pdf = await pdfjs.getDocument({ data }).promise;
    await pdf.destroy();
    return false;
  } catch (error) {
    return error instanceof Error && error.name === PASSWORD_EXCEPTION;
  }
};
